import React from 'react';
import ReactTooltip from 'react-tooltip';
import { bool, string, oneOf } from 'prop-types';

import { TOOLTIP_PLACES } from './constants';
import styles from './styles.module.scss';

function TooltipWrapper({ id, children, showTooltip, tooltipMessage, place, containerClassName }) {
  return showTooltip && tooltipMessage ? (
    <>
      <div className={containerClassName} data-tip data-place={place} data-for={id}>
        {children}
      </div>
      <ReactTooltip id={id} className={styles.tooltip} aria-haspopup="true" effect="solid">
        {tooltipMessage}
      </ReactTooltip>
    </>
  ) : (
    children
  );
}

TooltipWrapper.propTypes = {
  containerClassName: string,
  id: string,
  place: oneOf(Object.values(TOOLTIP_PLACES)),
  showTooltip: bool,
  tooltipMessage: string
};

TooltipWrapper.defaultProps = {
  containerClassName: '',
  showTooltip: false,
  tooltipMessage: ''
};

export default TooltipWrapper;
